import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Shell de carregamento da tela de detalhe da vaga — espelha o layout real
 * (nav + card de cabeçalho + barra de abas) enquanto a query por id carrega.
 */
export function VagaDetailsSkeleton() {
  return (
    <div className="min-h-screen bg-linear-to-br from-slate-50 to-blue-50/30">
      <div className="max-w-6xl mx-auto p-6 space-y-6">
        {/* Nav */}
        <div className="flex items-center justify-between bg-white/80 backdrop-blur-xs border border-slate-200 rounded-xl p-4">
          <Skeleton className="h-9 w-24" />
          <Skeleton className="h-9 w-32" />
        </div>

        {/* Card de cabeçalho da vaga */}
        <Card className="bg-white/80 backdrop-blur-xs border border-slate-200">
          <CardContent className="p-6 space-y-4">
            <div className="flex items-start gap-3">
              <Skeleton className="h-6 w-6 rounded" />
              <div className="space-y-2">
                <Skeleton className="h-7 w-64" />
                <Skeleton className="h-4 w-40" />
              </div>
            </div>
            <div className="flex flex-wrap gap-2">
              {[0, 1, 2, 3, 4].map((i) => (
                <Skeleton key={i} className="h-7 w-28 rounded-full" />
              ))}
            </div>
          </CardContent>
        </Card>

        {/* Barra de abas */}
        <div className="flex gap-2">
          <Skeleton className="h-10 w-40 rounded-lg" />
          <Skeleton className="h-10 w-40 rounded-lg" />
          <Skeleton className="h-10 w-40 rounded-lg" />
        </div>
        <Skeleton className="h-48 w-full rounded-xl" />
      </div>
    </div>
  );
}
